import { Columns3, Sparkles } from "lucide-react";
import { EKKO_DEFAULTS, ekkoList } from "@/lib/ekkoDefaults";
import { Box, TextField, inputClass } from "./fields";

const VALUES_COUNT = 4;
const PILLAR_NAMES = ["Pilar 1 (ícone de treino)", "Pilar 2 (ícone de fisioterapia)", "Pilar 3 (ícone de nutrição)"];

// Separador "Pilares & Valores": faixa verde de valores e os três cartões de pilares
export default function PillarsTab({ content, setContent }) {
  const values = Array.from({ length: VALUES_COUNT }, (_, i) => (content.values_items || [])[i] || "");
  const pillars = ekkoList(content, "pillars");

  const setValue = (index, text) => {
    const next = values.map((v, i) => (i === index ? text : v));
    setContent((prev) => ({ ...prev, values_items: next }));
  };

  const setPillar = (index, changes) => {
    const next = pillars.map((p, i) => (i === index ? { ...p, ...changes } : p));
    setContent((prev) => ({ ...prev, pillars: next }));
  };

  return (
    <div className="space-y-6">
      <Box title="Faixa de valores" icon={Sparkles} hint="As quatro palavras da faixa verde por baixo do topo. Vazio = valor por omissão.">
        <div className="grid sm:grid-cols-2 gap-3">
          {values.map((value, i) => (
            <input
              key={i}
              value={value}
              onChange={(e) => setValue(i, e.target.value)}
              placeholder={EKKO_DEFAULTS.values_items[i]}
              className={inputClass}
            />
          ))}
        </div>
      </Box>

      <Box title="Secção dos pilares" icon={Columns3}>
        <TextField label="Etiqueta (por cima do título)" field="pillars_eyebrow" content={content} setContent={setContent} />
        <TextField label="Título" field="pillars_title" content={content} setContent={setContent} />
        <TextField label="Subtítulo" field="pillars_subtitle" content={content} setContent={setContent} multiline rows={2} />

        {pillars.map((pillar, i) => (
          <div key={i} className="border border-[#3A3A3A] rounded p-3 space-y-2">
            <p className="text-[#F5F5F5] text-sm font-semibold">{PILLAR_NAMES[i]}</p>
            <input value={pillar.title || ""} onChange={(e) => setPillar(i, { title: e.target.value })} placeholder={EKKO_DEFAULTS.pillars[i]?.title || "Título"} className={inputClass} />
            <textarea rows={2} value={pillar.text || ""} onChange={(e) => setPillar(i, { text: e.target.value })} placeholder={EKKO_DEFAULTS.pillars[i]?.text || "Texto"} className={inputClass} />
            <input
              value={pillar.tags || ""}
              onChange={(e) => setPillar(i, { tags: e.target.value })}
              placeholder={`Etiquetas separadas por vírgula (ex.: ${EKKO_DEFAULTS.pillars[i]?.tags || "Recuperação, Mobilidade"})`}
              className={inputClass}
            />
          </div>
        ))}
      </Box>
    </div>
  );
}
